import React from 'react';

import { InfoItemProps } from '../InfoItem';
import { RedemptionCustomCard } from '../RedemptionCustomCard';

export interface RedemptionInProgressProps {
  title?: string;
  infos: InfoItemProps[];
  infoNote?: string;
  onClose: () => void;
}

export const RedemptionInProgress: React.FC<RedemptionInProgressProps> = ({
  infos,
  infoNote,
  onClose,
  title = 'Resgate em andamento.',
}) => {
  return (
    <RedemptionCustomCard
      iconType="waiting"
      infos={infos}
      onPrimaryButtonPress={onClose}
      title={title}
      infoNote={infoNote}
    />
  );
};
